<template>
  <Register />
</template>

<script>
import Register from '../components/Register.vue'
export default {
  components: {
    Register
  }
}
</script>

<style>

</style>
